import { isSuccessStatusCode } from 'owa-http-status-codes';
import { trace } from 'owa-trace';
import { logUsage } from 'owa-analytics';
import disableMergedViewAvailabilitySetting from '../services/disableMergedViewAvailabilitySetting';
import { setMergedViewEnabledAccount } from '../mutators/setMergedViewEnabledAccountMutatorActions';
import { getMergeViewEnabledAccount } from '../selectors/getMergeViewEnabledAccount';
import { updateMergedViewAvailabilityAccountCompleted } from '../actions/publicActions';

export default async function removeMergedViewAvailabilityAccount() {
    let mergedViewEnabledAccountSmtpAddress = getMergeViewEnabledAccount();
    let response;
    let updateSuccessful = false;

    if (mergedViewEnabledAccountSmtpAddress != null) {
        response = await disableMergedViewAvailabilitySetting(mergedViewEnabledAccountSmtpAddress);

        if (isSuccessStatusCode(response.status)) {
            setMergedViewEnabledAccount(null);
            updateSuccessful = true;
        } else {
            let error = response ? await response.text() : 'Unknown';
            trace.warn('removeMergedViewAvailabilityAccount failed with Error: ' + error);
        }
    } else {
        updateSuccessful = true;
    }

    updateMergedViewAvailabilityAccountCompleted(null, updateSuccessful);
    logUsage('removeMergedViewAvailabilityAccountStatus', {
        status: updateSuccessful,
    });
}
